import { ButtonProps } from '@mui/material';
import { Button as MaterialButton } from 'src/components/UI';

const Button = ({
  children = '',
  isActive = false,
  onToggle = () => { },
  onLoad = undefined,
  disabled = false,
  sx
}: {
  children?: string,
  isActive?: boolean,
  onToggle?: () => void,
  onLoad?: React.ReactEventHandler<HTMLButtonElement> | undefined,
  disabled?: boolean,
  sx?: ButtonProps['sx'];
}) => {
  return (
    <MaterialButton
      variant={isActive ? 'toggleContainedDark' : 'toggle'}
      onClick={onToggle}
      sx={[
        {
          minWidth: '0px',
          height: '28px',
        },
        ...(Array.isArray(sx) ? sx : [sx]),]}
      onLoad={onLoad}
      disabled={disabled}
    >
      {children}
    </MaterialButton>
  )
}

export default Button
